import React, { useEffect, useState } from "react";
import { use } from "react";
import { AiOutlineDownCircle, AiOutlineHistory } from "react-icons/ai";
import { IoIosArrowDropright, IoIosCloseCircleOutline } from "react-icons/io";
import { MdOutlinePlayCircle } from "react-icons/md";
import { useStores } from "../../../store";

const ScoreCircle = ({ score }) => {
  const circleRadius = 30;
  const circleCircumference = 2 * Math.PI * circleRadius;
  const strokeDashoffset =
    circleCircumference - (score / 100) * circleCircumference;

  const getColor = () => {
    if (score >= 50) return "#ff6b00";
    if (score >= 20 && score < 50) return "#ffc107";
    return "#20bf55";
  };

  const colorClass = getColor();

  return (
    <div className="flex justify-center items-center">
      <svg
        width="80"
        height="80"
        className="w-16 h-16 md:w-20 md:h-20"
        viewBox="0 0 80 80"
      >
        <g transform="rotate(-90 40 40)">
          <circle
            cx="40"
            cy="40"
            r={circleRadius}
            fill="transparent"
            stroke="#e0e0e0"
            strokeWidth="5"
          />
          <circle
            cx="40"
            cy="40"
            r={circleRadius}
            fill="transparent"
            stroke={colorClass}
            strokeWidth="5"
            strokeDasharray={circleCircumference}
            strokeDashoffset={strokeDashoffset}
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />
        </g>
        <text
          x="50%"
          y="52%"
          dominantBaseline="middle"
          textAnchor="middle"
          style={{
            fill: "#000",
            fontSize: "0.875rem",
            fontWeight: "bold",
          }}
        >
          {`${score}%`}
        </text>
      </svg>
    </div>
  );
};

const ProxyReport = ({ proxy }) => {
  const { RecuiterStore } = useStores();

  const proxyData =
    proxy || RecuiterStore.jobPostApplicant?.technicalInterview?.proxyId || {};

  const percentage = proxyData?.score || 0;

  const getColor = () => {
    if (percentage >= 50) return "#ff6b00";
    if (percentage >= 20 && percentage < 50) return "#ffc107";
    return "#20bf55";
  };

  useEffect(() => {
    console.log(proxyData, "proxy111");
  }, [500]);

  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  const colorClass = getColor();

  const colorClassForBackGround = `${colorClass}10`;
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div className=" flex flex-col  rounded-lg w-full border-b-2">
      {!isExpanded ? (
        <div className=" flex  justify-between items-center md:p-5 rounded-lg gap-4 w-full  mx-auto mb-5 md:mb-0">
          <div className=" flex flex-col w-full items-center gap-2 p-3 md:pl-0 pl-4">
            <div className="flex items-center justify-between w-full">
              <h3
                className={` md:text-lg font-semibold text-base flex items-center gap-2 whitespace-nowrap  `}
              >
                Proxy Analysis
                <sup className="md:text-xxs text-[9px]  opacity-50 font-normal ">
                  BETA
                </sup>
              </h3>
              {proxyData?.score ? (
                <button
                  className="bg-primary md:rounded-lg border md:px-4 md:py-2 flex items-center md:gap-2 whitespace-nowrap rounded-lg py-2 px-2 text-white"
                  onClick={() => {
                    setIsExpanded(true);
                  }}
                >
                  Check proxy report
                  <IoIosArrowDropright className="text-white" />
                </button>
              ) : null}
            </div>
            <div className=" md:flex flex w-full items-center !justify-between text-start  gap-2">
              {proxyData?.description ? (
                <p>{proxyData?.description}</p>
              ) : (
                <p className="text-md gil-med !text-start w-full  text-yellow">
                  Proxy Report Not Generated
                </p>
              )}
              <p></p>
            </div>
          </div>
          <div className="text-center hidden md:block "></div>
        </div>
      ) : (
        <>
          <div
            style={{ backgroundColor: colorClassForBackGround }}
            className="flex w-full  flex-col md:flex-row justify-between items-center  rounded-lg p-5 gap-4"
          >
            <div className="">
              <div className="flex w-full justify-between items-center">
                <h3
                  style={{ color: colorClass }}
                  className={` text-lg font-semibold`}
                >
                  Proxy report {""}
                  <sup className="md:text-xxs text-[9px]  text-black opacity-50 font-normal ">
                    BETA
                  </sup>
                </h3>
                <div className="text-center md:hidden ">
                  <ScoreCircle score={percentage} />
                  <p style={{ color: colorClass }} className={` text-sm `}>
                    proxy percentage
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-sm mt-2">
                {proxyData?.description}
              </p>
            </div>
            <div className="text-center hidden md:block ">
              <ScoreCircle score={percentage} />
              <p
                style={{ color: colorClass }}
                className={` text-sm mt-2 whitespace-nowrap`}
              >
                proxy percentage
              </p>
            </div>
          </div>
          <div className="px-5">
            {/* Section Cards */}

            {proxyData?.dualFaceDetection.length > 0 && (
              <div className="bg-white border-b-2 border-[#e0e0e0] p-4 mt-5">
                <div className="flex justify-between items-center">
                  <span className="text-black text-base font-medium">
                    Dual Face Detection
                  </span>
                  {/* <div className="flex items-center gap-1">
                  <span className=" text-sm cursor-pointer text-primary">
                    View more
                  </span>
                  <AiOutlineDownCircle className="text-primary" />
                </div> */}
                </div>

                {imageOpen ? (
                  <div
                    onClick={() => setImageOpen(false)}
                    className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center"
                  >
                    <div
                      className="bg-white w-[70vw] rounded-lg relative"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <img
                        src={imageUrl}
                        alt="image"
                        className="h-full w-full object-cover"
                      />
                    </div>
                  </div>
                ) : null}

                <p className="text-sm  mt-2" style={{ color: colorClass }}></p>
                <div className="flex flex-wrap gap-4 mt-4">
                  {proxyData?.dualFaceDetection?.map((section, index) => (
                    <div className="flex flex-col items-center w-20 md:w-24 gap-2 sm:w-16">
                      <div
                        className={` ml-2 h-14  w-20  md:h-16 "md:w-30" : "md:w-auto" sm:h-16 sm:w-24 flex items-center justify-center  border border-gray-300 bg-gray-100`}
                      >
                        {/* {section.type === "audio" ? (
                            <MdOutlinePlayCircle className="text-3xl text-gray-600" />
                          ) : ( */}
                        <img
                          src={section.url}
                          // alt={section.title}
                          onClick={() => {
                            setImageOpen(true);
                            setImageUrl(section.url);
                          }}
                          className="h-full w-full object-cover cursor-pointer"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = section.url;
                          }}
                        />
                        {/* )} */}
                      </div>
                      <div className="flex items-center text-xs gap-1">
                        <AiOutlineHistory color="#ff6b00" />
                        <span className="text-gray-600">{section?.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {proxyData?.headPosition.length > 0 && (
              <div className="bg-white border-b-2 border-[#e0e0e0] p-4 mt-5">
                <div className="flex justify-between items-center">
                  <span className="text-black text-base font-medium">
                    Head Position
                  </span>
                  {/* <div className="flex items-center gap-1">
                  <span className=" text-sm cursor-pointer text-primary">
                    View more
                  </span>
                  <AiOutlineDownCircle className="text-primary" />
                </div> */}
                </div>

                <p className="text-sm  mt-2" style={{ color: colorClass }}></p>
                <div className="flex flex-wrap gap-4 mt-4">
                  {proxyData?.headPosition?.map((section, index) => (
                    <div className="flex flex-col items-center w-20 md:w-24 gap-2 sm:w-16">
                      <div
                        className={` ml-2 h-14  w-20  md:h-16 "md:w-30" : "md:w-auto" sm:h-16 sm:w-24 flex items-center justify-center  border border-gray-300 bg-gray-100`}
                      >
                        {/* {section.type === "audio" ? (
                            <MdOutlinePlayCircle className="text-3xl text-gray-600" />
                          ) : ( */}
                        <img
                          src={section.url}
                          // alt={section.title}
                          onClick={() => {
                            setImageOpen(true);
                            setImageUrl(section.url);
                          }}
                          className="h-full w-full object-cover cursor-pointer"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = section.url;
                          }}
                        />
                        {/* )} */}
                      </div>
                      <div className="flex items-center text-xs gap-1">
                        <AiOutlineHistory color="#ff6b00" />
                        <span className="text-gray-600">{section?.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {proxyData?.tabShiftingDetection.length > 0 && (
              <div className="bg-white border-b-2 border-[#e0e0e0] p-4 mt-5">
                <div className="flex justify-between items-center">
                  <span className="text-black text-base font-medium">
                    Tab Shifting
                  </span>
                  {/* <div className="flex items-center gap-1">
                  <span className=" text-sm cursor-pointer text-primary">
                    View more
                  </span>
                  <AiOutlineDownCircle className="text-primary" />
                </div> */}
                </div>

                <p className="text-sm  mt-2" style={{ color: colorClass }}></p>
                <div className="flex flex-wrap gap-4 mt-4">
                  {proxyData?.tabShiftingDetection?.map((section, index) => (
                    <div className="flex flex-col items-center w-20 md:w-24 gap-2 sm:w-16">
                      <div
                        className={` ml-2 h-14  w-20  md:h-16 "md:w-30" : "md:w-auto" sm:h-16 sm:w-24 flex items-center justify-center  border border-gray-300 bg-gray-100`}
                      >
                        {/* {section.type === "audio" ? (
                            <MdOutlinePlayCircle className="text-3xl text-gray-600" />
                          ) : ( */}
                        <img
                          src={section.url}
                          // alt={section.title}
                          onClick={() => {
                            setImageOpen(true);
                            setImageUrl(section.url);
                          }}
                          className="h-full w-full object-cover cursor-pointer"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = section.url;
                          }}
                        />
                        {/* )} */}
                      </div>
                      <div className="flex items-center text-xs gap-1">
                        <AiOutlineHistory color="#ff6b00" />
                        <span className="text-gray-600">{section?.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}{" "}
    </div>
  );
};

export default ProxyReport;
